import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
import TopbarS2 from '../TopbarS2/TopbarS2'

/* Homefullviewimage */
import Home1 from '../../images/home/modern-architecture.jpg'
import Home2 from '../../images/home/classic-architecture.jpg'
import Home3 from '../../images/home/modern-architecture-s2.jpg'
import Home4 from '../../images/home/classic-architecture-dark.jpg'
import Home5 from '../../images/home/classic-interior-design.jpg'
import Home6 from '../../images/home/classic-interior-design-s2.jpg'
import Home7 from '../../images/home/classic-interior-design-dark.jpg'
import Home8 from '../../images/home/renovation.jpg'
import Home9 from '../../images/home/modern-woocommerce.jpg'
import Home10 from '../../images/home/minimal-woocommerce-s2.jpg'
import Home11 from '../../images/home/urban-planning.jpg'
import Home12 from '../../images/home/costruction.jpg'
import Home13 from '../../images/home/costruction-s2.jpg'
import Home14 from '../../images/home/construction-profile.jpg'
import Home15 from '../../images/home/frelancer-architect.jpg'

const ClickHandler = () => {
  window.scrollTo(10, 0)
}

const Header = (props) => {
  const [menuActive, setMenuState] = useState(false)

  const SubmitHandler = (e) => {
    e.preventDefault()
  }

  return (
    <>
      <header id="header">
        <TopbarS2 />
        <div className={"" + props.hclass}>
          <nav className="navigation navbar navbar-expand-lg navbar-light">
            <div className="container-fluid">
              <div className="row align-items-center g-0">
                <div className={"" + props.col1}>
                  <div className="mobail-menu">
                    <MobileMenu />
                  </div>
                </div>

                <div className={"" + props.col2}>
                  <div className="navbar-header">
                    <Link onClick={ClickHandler} className="navbar-brand" to="/home">
                      <img src={props.Logo} alt="" />
                    </Link>
                  </div>
                </div>

                <div className={"" + props.col3}>
                  <div id="navbar" className="collapse navbar-collapse navigation-holder">
                    <button className="menu-close">
                      <i className="ti-close"></i>
                    </button>

                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                      <li className="menu-item-has-children">
                        <Link onClick={ClickHandler} to="/home">Home</Link>
                      </li>

                      <li className="menu-item-has-children">
                        <Link onClick={ClickHandler} to="/about">About Us</Link>
                      </li>

                      <li className="menu-item-has-children">
                                              <Link onClick={ClickHandler} to="/services">Services</Link>
                                               <ul className="sub-menu">
                                                                        <li><Link onClick={ClickHandler} to="/service-single/architectural">Architectural</Link></li>
                                                                        <li><Link onClick={ClickHandler} to="/service-single/interiors">Interiors</Link></li>
                                                                        <li><Link onClick={ClickHandler} to="/service-single/design-planning">Design & Planning</Link></li>
                                                                        {/* <li><Link onClick={ClickHandler} to="/service-single/Landscaping">Landscaping</Link></li> */}
                                                                      </ul>
                                            </li>

                      <li className="menu-item-has-children">
                        <Link onClick={ClickHandler} to="/projects">Projects</Link>
                        {/* <ul className="sub-menu">
                          <li><Link onClick={ClickHandler} to="/projects">Projects</Link></li>
                          <li><Link onClick={ClickHandler} to="/project-single/Modern-House-In-UK">Projects Single</Link></li>
                        </ul> */}
                      </li>

                      <li className="menu-item-has-children">
                        <Link onClick={ClickHandler} to="/blog">Blogs</Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className={"" + props.col4}>
                  <div className="header-right">
                    <div className="close-form">
                      <Link className="theme-btn" onClick={ClickHandler} to="/contact">
                        Contact Now
                      </Link>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </nav>
        </div>
      </header>

      {/* ================= WHATSAPP FLOATING BUTTON ================= */}
      <a
  href="https://wa.me/+917331149267"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    position: 'fixed',
    right: '20px',
    bottom: '20px',
    width: '56px',
    height: '56px',
    backgroundColor: '#25D366',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
    zIndex: 9999
  }}
>
  <img
    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
    alt="WhatsApp"
    style={{
      width: '28px',
      height: '28px'
    }}
  />
</a>

      {/* ============================================================ */}
    </>
  )
}

export default Header
